export default __webpack_public_path__ + "static/media/clock.8a198729.png";